import type { ComponentProps, FC, PropsWithChildren } from "react";
import React from "react";
import { QueryClientProvider as OriginalClientProvider } from "react-query";

import { QueryScopeBoundary } from "./query-scope-boundary";

export type QueryClientProviderProps = PropsWithChildren<ComponentProps<typeof OriginalClientProvider>>;

export const QueryClientProvider: FC<QueryClientProviderProps> = (props) => (
	<QueryScopeBoundary>
		<OriginalClientProvider {...props} />
	</QueryScopeBoundary>
);
